import { z } from 'zod'
import { ComponentCategory } from '../enums'
import { Id } from './common'

/** Spend in one currency. Different currencies are never added together. */
export const CostTotals = z.object({
  currency: z.string(),
  purchase_minor: z.number().int(),
  parts_minor: z.number().int(),
  service_minor: z.number().int(),
  total_minor: z.number().int(),
  /** Parts plus servicing: what riding the bike costs, without buying it. */
  running_minor: z.number().int(),
  /** What the bike sold for, if it has been sold. */
  sale_minor: z.number().int(),
  /** Total spent less the sale price. */
  net_minor: z.number().int(),
})
export type CostTotals = z.infer<typeof CostTotals>

export const PartCost = z.object({
  id: Id,
  name: z.string(),
  category: ComponentCategory,
  fitted: z.boolean(),
  price_minor: z.number().int(),
  currency: z.string(),
  distance_m: z.number(),
  moving_time_s: z.number(),
})
export type PartCost = z.infer<typeof PartCost>

export const CostSummary = z.object({
  totals: z.array(CostTotals),
  /** Everything ridden on the bike. */
  distance_m: z.number(),
  moving_time_s: z.number(),
  /** Priced parts first bought for this bike, most expensive to run first. */
  parts: z.array(PartCost),
  unpriced_parts: z.number().int(),
  unpriced_services: z.number().int(),
})
export type CostSummary = z.infer<typeof CostSummary>
